<template>
  <div class="handle-in-time">
    <div class="flex-align-center" style="margin-bottom: 15px">
      <img src="@/assets/imgs/school/monthRecord/star.png" alt="" class="star" />
      <div class="title title-2" style="color: #304efa">处理及时班主任</div>
    </div>
    <div v-if="dataSource.length" class="list">
      <div v-for="(item, index) in dataSource" :key="index" class="list-item flex-align-center">
        <img
          :src="require(`@/assets/imgs/school/monthRecord/rank${index + 1}.png`)"
          class="rank-icon"
          alt=""
          style="margin-right: 10px"
        />
        <div>{{ item.className }}</div>
        <div style="margin: 0 10px">|</div>
        <div class="teacher-name">{{ item.teacherName }}</div>
        <div style="margin-left: 60px">
          处理率：
          <span style="color: #54adf6">{{ item.dealRate }}%</span>
        </div>
        <div style="margin: 0 10px">
          已处理提醒：
          <span style="color: #54adf6">{{ item.dealCount }}</span>
        </div>
        <div>
          未处理提醒：
          <span>{{ item.sumCount - item.dealCount }}</span>
        </div>
      </div>
    </div>
    <!--空状态-->
    <EmptyData v-else />
    <a-divider style="margin: 15px 0" />
    <div v-if="dataSource.length" class="bottom-text">
      说明：班级学生情绪状态整体良好，无异常提醒，班级管理成效显著
    </div>
  </div>
</template>
<script>
export default {
  name: 'HandleInTime',
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="less">
.handle-in-time {
  padding: 20px;
  background-color: #edf4ff;
  border-radius: 10px;
  .star {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .list {
    .list-item {
      padding: 10px 15px;
      margin-bottom: 10px;
      border-radius: 5px;
      background-color: #fff;
      .rank-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
  .bottom-text {
    line-height: 1.5;
  }
}
</style>
